module.exports = __webpack_public_path__ + "img/WannaBePosturePerfectLab.480be59e.png";